import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    QueryList,
    ViewChild,
    ViewChildren
} from "@angular/core";
import {MenuModel} from "../menu.model";
import {MenuEvents} from "../menu-events";
import {Observable, Subject, Subscription} from "rxjs";

@Component({
    selector: "woa-menu-subcategory-anchor-panel",
    templateUrl: "./menu-subcategory-anchor-panel.component.html"
})
export class MenuSubcategoryAnchorPanelComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild("scroller") protected scroller: ElementRef;
    @ViewChildren("anchor") protected anchors: QueryList<ElementRef>;

    public scrolling$: Subject<void> = new Subject();
    private scrollingComplete$: Observable<void> = this.scrolling$.debounceTime(10);
    private subscriptions: Subscription = new Subscription();

    constructor(public menuModel: MenuModel,
                public changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.subscriptions.add(MenuEvents.menuBuilt$.subscribe(() => this.changeDetectorRef.detectChanges()));
        this.subscriptions.add(MenuEvents.anchorSelected$.subscribe(() => this.changeDetectorRef.detectChanges()));
        this.subscriptions.add(this.scrollingComplete$.subscribe(() => this.changeDetectorRef.detectChanges()));
    }

    ngAfterViewInit(): void {
        this.subscriptions.add(MenuEvents.scrollAnchorBar$.subscribe((anchorIndex: number) => {
            if (anchorIndex == undefined || !this.scroller) {
                return;
            }
            const anchor: ElementRef = this.anchors.toArray()[anchorIndex];
            if (anchor) {
                this.scroller.nativeElement.scrollTo({
                    left: anchor.nativeElement.offsetLeft - 45,
                    behavior: "smooth"
                });
            }
        }));
        MenuEvents.menuBuilt$.next();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/menu/menu-subcategory-anchor-panel/menu-subcategory-anchor-panel.component.ts